// Chave ÚNICA de persistência do tour "o que mudou" do redesign de cabeçalho +
// filtros. Todas as views que exibem esse tour (CRM, IA alterações, Compliance,
// Consolidador, Minha Carteira) compartilham esta chave: dispensar o tour em UM
// módulo dispensa em TODOS. Antes cada view tinha chave própria e o mesmo
// anúncio reaparecia a cada tela nova — a queixa que motivou esta mudança.
//
// Cada view continua dona dos seus `steps`/`targets`; só a persistência é
// compartilhada. Ao anunciar uma nova onda de redesign, incremente `version` e o
// tour reabre uma vez para todos. Ver @modules/global/utils/whatsnew-storage.
//
// Uma view que precise de tour independente no futuro basta declarar seu próprio
// { moduleKey, version } no lugar deste spread.

export const PAGE_HEADER_WHATSNEW = {
  moduleKey: 'page_header_filtros',
  version: 1,
}
